import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

function PuzzleBoard() {
  const [gridItems, setGridItems] = useState([]);

  const [time , setTime] = useState({ms:0 , s:0 , m:0});
  const [interv , setInterv] = useState();
  const [bestTime , setBestTime] = useState({ms:0 , s:0 , m:0});
  const [totalClicks , setTotalClicks] = useState(0)                //total clicks state
  const [perfectRun, setPerfectRun] = useState(false); // state to track perfect run

  const [clickedItems, setClickedItems] = useState(Array(26).fill(false));
  const [currentSequentialNumber, setCurrentSequentialNumber] = useState(0);

  useEffect(() => {
    const shuffledAlphabets = Array.from({ length: 26 }, (_, i) => String.fromCharCode(97 + i)).sort(() => Math.random() - 0.5);
    setGridItems(shuffledAlphabets);
    starttimer();
    clearInterval(interv);
  }, []);



  const handleGridItemClick = (index) => {
    setTotalClicks((prevTotalClicks) => prevTotalClicks + 1);
    // console.log(gridItems[index]);
    // gridItems[index] === String.fromCharCode(97 + currentSequentialNumber)
        if (gridItems[index] === String.fromCharCode(97+currentSequentialNumber)) {
            const newClickedItems = clickedItems.slice();
            newClickedItems[index] = true;
            setClickedItems(newClickedItems);
            setCurrentSequentialNumber(currentSequentialNumber + 1);
            // console.log(`Clicked item number: ${gridItems[index]}`);
            if (gridItems[index] === 'z') {
              const currentTimeMS = time.m * 60000 + time.s * 1000 + time.ms;
              const bestTimeMS = bestTime.m * 60000 + bestTime.s * 1000 + bestTime.ms;
              
              if (currentTimeMS < bestTimeMS || bestTimeMS === 0) {
                setBestTime({ ms: time.ms, s: time.s, m: time.m });
              }

              if (totalClicks === 25) {
                toast.success("⚡⚡⚡Perfect run⚡⚡⚡");
                setPerfectRun(true);
                setTimeout(() => {
                setPerfectRun(false);
                }, 3000); 
              }else{toast.success("🦄 Won");}
            }
        }
        else{
          toast.error('Thats wrong', {
            position: "top-center",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        }
  };

  const handleReset = () => {
    const shuffledAlphabets = Array.from({ length: 26 }, (_, i) => String.fromCharCode(97 + i)).sort(() => Math.random() - 0.5);
    setGridItems(shuffledAlphabets);
    setClickedItems(Array(26).fill(false));
    setCurrentSequentialNumber(0);
    resetTimer();
    setTotalClicks(0);
    setPerfectRun(false);
  };

  const renderGrid = () => {
    return gridItems.map((item, index) => (
      <div
        key={index}
        className={`font-bold text-[#ffffff] ${clickedItems[index] ? 'bg-[#00FF75]' : 'bg-[#FF008A]'
        } border-solid border-[5px] border-[#276ED8] p-2 m-1 text-3xl flex justify-center items-center rounded cursor-pointer w-[70px] h-[70px]`}
        onClick={() => handleGridItemClick(index)}
      >
        <div className='flex justify-center items-center'>{item}</div>
      </div>
    ));
  };

  //Stopwatch ------------------------------------------------------------------------
  
  const starttimer = () => {
    setInterv(setInterval(runTimer, 10));

  }
  
  const runTimer = () => {
    setTime((prevTime) => {
      let updatedMS = prevTime.ms + 1,
        updatedS = prevTime.s,
        updatedM = prevTime.m;
      if (updatedMS === 100) {
        updatedS++;
        updatedMS = 0;
      }
      if (updatedS === 60) {
        updatedM++;
        updatedS = 0;
      }
      return { ms: updatedMS, s: updatedS, m: updatedM };
    });
  };
  

  const resetTimer = () => {
    clearInterval(interv); // Clear the interval
    setTime({ ms: 0, s: 0, m: 0 }); // Reset time
    starttimer();
  };

  //Stopwatch ------------------------------------------------------------------------


  const rainbowBgClass = perfectRun ? 'rainbow-bg' : ''; // Add rainbow background class conditionally


  return (
    <>
      {/* <NavBarInGame/> */}
      <div className={`flex flex-col justify-center items-center h-screen bg-[#111624] ${rainbowBgClass}`}>
          <div className='bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2'>
              <h1 className='text-[#FF008A]'>Best score = </h1>
              <div className='mx-2'>
                  <h1>{(bestTime.m >= 10) ? bestTime.m : "0" + bestTime.m}</h1>
              </div>
              <p>:</p>
              <div className='mx-2'>
                  <h1>{(bestTime.s >= 10) ? bestTime.s : "0" + bestTime.s}</h1>
              </div>
              <p>:</p>
              <div className='mx-2'>
                  <h1>{(bestTime.ms >= 10) ? bestTime.ms : "0" + bestTime.ms}</h1>
              </div>
          </div>
          <div className='bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2'>
            <h1>Total amount of clicks : {totalClicks} </h1>
          </div>
          <div className='bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2'>
              <div className='mx-2'>
                  <h1>{(time.m >= 10) ? time.m : "0" + time.m}</h1>
              </div>
              <p>:</p>
              <div className='mx-2'>
                  <h1>{(time.s >= 10) ? time.s : "0" + time.s}</h1>
              </div>
              <p>:</p>
              <div className='mx-2'>
                  <h1>{(time.ms >= 10) ? time.ms : "0" + time.ms}</h1>
              </div>
          </div>
        <div className='grid grid-cols-5 grid-rows-6'>{renderGrid()}</div>

        <button className='bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2' 
                onClick={handleReset}>
                Reset
        </button>
        
        <Link to="/" className='bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2'>
          Home
        </Link>
      </div>
    </>
  );
}

export default PuzzleBoard;